<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <svg-icon class-name="international-icon" icon-class="language" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='zh'" command="zh">
        中文
      </el-dropdown-item>
      <el-dropdown-item :disabled="language==='en'" command="en">
        English
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { commonApi } from '@/api';
export default {
  computed: {
    language() {
      // return this.$store.getters.language;
      return this.$store.state.app.language;
    }
  },
  methods: {
    handleSetLanguage(lang) {
      commonApi.changeLang({
        lang: lang == 'zh' ? 'zh_CN' : 'en_US'
      }).then(() => {
          this.$i18n.locale = lang;
          this.$store.dispatch('app/setLanguage', lang);
          this.$router.go(0);
      }).catch(() => {
          this.$i18n.locale = lang;
          this.$store.dispatch('app/setLanguage', lang);
          this.$router.go(0);
      });
    }
  }
};
</script>
